<template>
  <div class="table_wrap">
    <div class="filter-push-div">
      <el-table-column label="성별" class-name="text-center" >
        <el-radio-group  class="link-radio" v-model="genderData" @change="parentChange('gender', genderData)">
          <el-radio :label="0" :value="0">전체</el-radio>
          <el-radio :label="1" :value="1">남자</el-radio>
          <el-radio :label="2" :value="2">여자</el-radio>
        </el-radio-group>
      </el-table-column>
    </div>
  </div>
</template>

<script>
import dateMixins from "@/mixins/dateMixins";

export default {
  name: "SetGenderLayout",
  mixins: [dateMixins],
  inject: ['pushTypeSetData'],
  components: {},
  provide() {
    return {}
  },
  props: {
    setData: {default: () => []},
    paginationData: {
      default: () => { return { total: 0, page: 0, size: 0, }}
    },
    originData : {
      type : Object
    }

  },
  data() {
    return {
      genderData : 0
    }
  },
  created() {},
  mounted() {
    this.initState()
  },
  beforeDestroy() {
  },
  destroyed() {},
  computed: {
  },
  methods: {
    initState(){
      this.parentChange('gender',this.originData.gender);
    },
    parentChange(key,value){
      this.genderData = value;
      this.pushTypeSetData(key, value)
    },

    tableIdx(index) {
      return this.paginationData.total - index - (this.paginationData.page - 1) * this.paginationData.size;
    },


  },
  watch: {},
}
</script>

<style scoped>

</style>